// Milestone 1: serve a minimal env payload mirroring what
// src/main/main.js's `env:get` IPC returns. The renderer only reads
// a handful of these fields (SCREENPLAY_ENV, APP_NAME_SUFFIX,
// STRIPE_PUBLISHABLE_KEY); the rest are best-effort defaults so any
// future reads degrade to "" rather than undefined errors.

const PUBLIC_ENV = (() => {
  const env = (typeof import.meta !== 'undefined' && import.meta.env) || {};
  return {
    SCREENPLAY_ENV: env.VITE_SCREENPLAY_ENV || env.MODE || 'development',
    SUPABASE_URL: env.VITE_SUPABASE_URL || '',
    SUPABASE_ANON_KEY: env.VITE_SUPABASE_ANON_KEY || '',
    APP_NAME_SUFFIX: env.VITE_APP_NAME_SUFFIX || ' (Web)',
    STRIPE_PUBLISHABLE_KEY: env.VITE_STRIPE_PUBLISHABLE_KEY || '',
    OAUTH_REDIRECT_SCHEME: null,
  };
})();

export function getPublicEnv() {
  return PUBLIC_ENV;
}

export function buildEnvHandlers() {
  return {
    envInfo: () => Promise.resolve({ ok: true, ...PUBLIC_ENV }),
  };
}
